import type {
  Login,
  RespondToAuthChallenge,
  Logout,
  GetAuthCompanyAndUser,
  ResetPassword,
  ResetPasswordConfirm,
  ChangePassword,
} from '@/types/api/customer/Auth'

import { useApiForPublic, useApiForCustomer } from '@/composables/useApi'

/**
 * ログインする
 */
export const login: Login = payload =>
  useApiForPublic('/rest/auth/login', {
    method: 'POST',
    body: {
      payload,
    },
  })

/**
 * 多要素認証のチャレンジをする
 */
export const respondToAuthChallenge: RespondToAuthChallenge = payload =>
  useApiForPublic('/rest/auth/login/mfa', {
    method: 'POST',
    body: {
      payload,
    },
  })

/**
 * ログアウトする
 */
export const logout: Logout = () =>
  useApiForCustomer('/rest/auth/logout', {
    method: 'POST',
  })

/**
 * ログインしているアカウントの会社情報とユーザー情報を取得する
 */
export const getAuthCompanyAndUser: GetAuthCompanyAndUser = () =>
  useApiForCustomer('/rest/auth/user', {
    method: 'GET',
  })

/**
 * パスワードのリセットをリクエストする
 */
export const resetPassword: ResetPassword = email =>
  useApiForPublic('/rest/auth/resetpassword', {
    method: 'POST',
    body: {
      payload: {
        email,
      },
    },
  })

/**
 * ユーザー編集画面でパスワードのリセットをリクエストする
 */
export const changePassword: ChangePassword = email =>
  useApiForPublic('/rest/auth/change-password', {
    method: 'POST',
    body: {
      payload: {
        email,
      },
    },
  })

/**
 * パスワードをリセットする
 */
export const resetPasswordConfirm: ResetPasswordConfirm = (email, confirmationCode, password) =>
  useApiForPublic('/rest/auth/resetpassword/confirm', {
    method: 'POST',
    body: {
      payload: {
        email,
        confirmationCode,
        password,
      },
    },
  })
